// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2d38J","requiredAsterisk":"Info_requiredAsterisk__3Zh49"};